module.exports = __webpack_public_path__ + "static/media/filters-icon.f053e6ab.svg";